export const USER_CURRENCY_COOKIE = "edx_user_currency";
export const DEFAULT_CURRENCY = "USD";

export const ACCEPTED_CURRENCY_CODES = [
  "USD",
  "INR",
  "EUR",
  "GBP",
  "BRL",
  "MXN",
] as const;

export const DEFAULT_MULTI_CURRENCY_TOOLTIP =
  "The displayed local price is for reference only. Final charges will be made in USD.";
